import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-config-delete-compensation',
  templateUrl: './config-delete-compensation.component.html',
  styleUrls: ['./config-delete-compensation.component.scss']
})
export class ConfigDeleteCompensationComponent implements OnInit {
  @Input() value!: string;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    if(this.value) this.change.emit(this.value);
  }


}
